import { useTranslation } from "react-i18next";
import { useSettingsUtils } from "../../Settings/useSettingsUtils";
import { Breadcrumbs } from "@unified-checkout/design-system";
import styles from "./header.module.scss";

export const Header = () => {

  const { t } = useTranslation();
  const { internalPagesBreadcrumbs } = useSettingsUtils();

  return (
    <div className={styles["header"]}>

      <div className={styles["header__breadcrumbs"]}>
        <Breadcrumbs linksProps={internalPagesBreadcrumbs.SERVICES} />
      </div>

      <div className={styles["header__header-box"]}>

        <div className={styles["header__header-box__info"]}>

          <div className={styles["header__header-box__info__title"]}>
            <span>
              {t('innerLayout.servicesPage.title')}
            </span>
          </div>

          <div className={styles["header__header-box__info__subtitle"]}>
            {t('innerLayout.servicesPage.subTitle')}
          </div>

        </div>

      </div>
    </div>
  )
};